import HowItWork from "../page/HowItWork";

const HowItWorksSection = () => {
    return (
        <section
            id="how-it-works"
            data-section
            data-title="How it works"
            aria-label="How it works"
            className="relative w-full min-h-screen"
        >
            <HowItWork />
        </section>
    );
};

export default HowItWorksSection;
